import React, { useState, useEffect } from 'react';
import { submitComplaint, getMyComplaints } from '../../api';
import { toast } from 'react-toastify';

const StudentComplaints = () => {
  const [complaints, setComplaints] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [complaintData, setComplaintData] = useState({ subject: '', description: '' });

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    try {
      const c = await getMyComplaints();
      setComplaints(c.data);
    } catch (err) {
      toast.error('Error loading data');
    }
  };

  const handleComplaint = async (e) => {
    e.preventDefault();
    try {
      await submitComplaint(complaintData);
      toast.success('Complaint submitted!');
      setShowForm(false);
      setComplaintData({ subject: '', description: '' });
      loadData();
    } catch (err) {
      toast.error('Error submitting complaint');
    }
  };

  return (
    <div>
      <div style={styles.header}>
        <h3 style={styles.title}>💬 My Complaints</h3>
        <button style={styles.addBtn} onClick={() => setShowForm(!showForm)}>
          + New Complaint
        </button>
      </div>

      {showForm && (
        <div style={styles.formCard}>
          <h4 style={styles.formTitle}>Submit Complaint</h4>
          <form onSubmit={handleComplaint}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Subject</label>
              <input style={styles.input} placeholder="Complaint subject"
                value={complaintData.subject}
                onChange={e => setComplaintData({...complaintData, subject: e.target.value})} required />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Description</label>
              <textarea style={styles.textarea} rows={4}
                placeholder="Describe your complaint..."
                value={complaintData.description}
                onChange={e => setComplaintData({...complaintData, description: e.target.value})} required />
            </div>
            <div style={styles.btnGroup}>
              <button type="submit" style={styles.addBtn}>Submit</button>
              <button type="button" style={styles.cancelBtn}
                onClick={() => setShowForm(false)}>Cancel</button>
            </div>
          </form>
        </div>
      )}

      {complaints.map(c => (
        <div key={c.id} style={styles.complaintCard}>
          <div style={styles.complaintHeader}>
            <h4 style={styles.complaintTitle}>{c.subject}</h4>
            <span style={{
              ...styles.statusBadge,
              background: c.status === 'pending' ? '#fff3cd' :
                c.status === 'reviewed' ? '#cce5ff' : '#d4edda',
              color: c.status === 'pending' ? '#856404' :
                c.status === 'reviewed' ? '#004085' : '#155724'
            }}>
              {c.status}
            </span>
          </div>
          <p style={styles.complaintText}>{c.description}</p>
          {c.admin_reply && (
            <div style={styles.replyBox}>
              <p style={styles.replyLabel}>Admin Reply:</p>
              <p style={styles.replyText}>{c.admin_reply}</p>
            </div>
          )}
          <p style={styles.date}>
            {new Date(c.created_at).toLocaleDateString()}
          </p>
        </div>
      ))}

      {complaints.length === 0 && !showForm && (
        <div style={styles.empty}>No complaints submitted yet!</div>
      )}
    </div>
  );
};

const styles = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  title: { color: '#1a3a5c', margin: 0 },
  addBtn: { padding: '10px 20px', background: '#0d6efd', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' },
  cancelBtn: { padding: '10px 20px', background: '#6c757d', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' },
  formCard: { background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  formTitle: { color: '#1a3a5c', margin: '0 0 15px' },
  inputGroup: { marginBottom: '15px' },
  label: { fontSize: '13px', fontWeight: '600', color: '#555', display: 'block', marginBottom: '5px' },
  input: { padding: '10px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px', width: '100%' },
  textarea: { padding: '10px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px', width: '100%', resize: 'vertical' },
  btnGroup: { display: 'flex', gap: '10px' },
  complaintCard: { background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '15px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  complaintHeader: { display: 'flex', justifyContent: 'space-between', marginBottom: '10px' },
  complaintTitle: { color: '#1a3a5c', margin: 0 },
  statusBadge: { padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '600' },
  complaintText: { color: '#555', fontSize: '14px', margin: '0 0 10px' },
  replyBox: { background: '#e8f4fd', borderRadius: '8px', padding: '12px', marginBottom: '10px' },
  replyLabel: { color: '#0d6efd', fontSize: '12px', fontWeight: '600', margin: '0 0 5px' },
  replyText: { color: '#444', fontSize: '13px', margin: 0 },
  date: { color: '#999', fontSize: '12px', margin: 0 },
  empty: { textAlign: 'center', color: '#999', padding: '40px', background: 'white', borderRadius: '12px' },
};

export default StudentComplaints;